// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2Hzzp","buttons":"PendingPaymentAlert_buttons__1dvJQ"};